export const BUTTON_ZOOM_IN_FACTOR = 1.2;
export const BUTTON_ZOOM_OUT_FACTOR = 0.8;
export const DEFAULT_MAP_PORTION = 0.8;

export const MOBILE_PAGE = {
  MAP: 'map',
  LIST: 'list',
};
